/** Adds dots and infinite-style navigation to the product-list carousels. */
(function () {
  function init(section) {
    var slideshowEl = section.querySelector('slideshow-component');
    if (!slideshowEl || slideshowEl.dataset.vcDotsInit) return;
    slideshowEl.dataset.vcDotsInit = 'true';

    // Product cards can contain nested galleries; scope to the carousel's direct track.
    var scroller = slideshowEl.querySelector(':scope > slideshow-container > slideshow-slides');
    var slides = scroller ? Array.from(scroller.children) : [];
    if (slides.length < 2) return;

    // The shared resource-list carousel defaults to finite navigation; enable it here only.
    slideshowEl.setAttribute('infinite', '');
    slideshowEl.current = slideshowEl.current;

    // Stable IDs remain correct when the real slide nodes are rotated below.
    var slideIds = slides.map(function (slide, index) {
      if (!slide.getAttribute('slide-id')) slide.setAttribute('slide-id', 'vc-carousel-slide-' + index);
      return slide.getAttribute('slide-id');
    });
    var pointer = 0;

    // Native slides have limited scroll range because they are not cloned. Rotate slides that have
    // left the viewport and compensate with an instant scroll so the next target remains reachable.
    // Track pending self-generated scroll events so the edge observer does not relocate twice.
    var pendingSelfScrolls = 0;
    function relocateOne(direction) {
      if (direction > 0) {
        var first = scroller.firstElementChild;
        var second = first ? first.nextElementSibling : null;
        if (!first || !second) return false;
        var forwardPitch = second.offsetLeft - first.offsetLeft;
        scroller.appendChild(first);
        pendingSelfScrolls++;
        scroller.scrollTo({ left: scroller.scrollLeft - forwardPitch, behavior: 'instant' });
      } else {
        var last = scroller.lastElementChild;
        var prev = last ? last.previousElementSibling : null;
        if (!last || !prev) return false;
        var backwardPitch = last.offsetLeft - prev.offsetLeft;
        scroller.insertBefore(last, scroller.firstElementChild);
        pendingSelfScrolls++;
        scroller.scrollTo({ left: scroller.scrollLeft + backwardPitch, behavior: 'instant' });
      }
      return true;
    }

    function makeReachable(slide, direction) {
      var guard = slides.length;
      var paddingStart = parseFloat(getComputedStyle(scroller).paddingInlineStart) || 0;
      while (guard-- > 0) {
        var maxScroll = scroller.scrollWidth - scroller.clientWidth;
        var target = slide.offsetLeft - paddingStart;
        if (target >= -1 && target <= maxScroll + 1) return;
        if (!relocateOne(direction)) return;
      }
    }

    // Real bug fixed 2026-08-07 (reported after the fix above): that fix only covered the arrow
    // and dot buttons -- native mouse-drag (pointer-capture, #handleMouseDown in slideshow.js) and
    // native touch-scroll (the scroller is a plain CSS overflow-x container, so touch devices pan
    // it directly, no JS involved) both move the scroller's real scrollLeft straight through the
    // browser's own clamping, hitting the exact same "no clone slides" ceiling makeReachable works
    // around for clicks -- explaining why a drag could only move ~1 slide's worth before running
    // out of physical scroll room, regardless of how far the gesture continued. Can't hook the drag
    // itself (its pointermove/pointerup listeners live on #handleMouseDown, a true private class
    // field, unreachable from outside), so this reacts to the *result* instead: whenever the
    // scroller is sitting within 1px of either edge, relocate one more slide onto that edge, the
    // same way a button press would have.
    function extendIfAtEdge() {
      var maxScroll = scroller.scrollWidth - scroller.clientWidth;
      if (maxScroll <= 1) return;
      if (scroller.scrollLeft >= maxScroll - 1) {
        relocateOne(1);
      } else if (scroller.scrollLeft <= 1) {
        relocateOne(-1);
      }
    }

    // 'scroll' fires continuously while a drag is in progress, so one relocation per event keeps
    // pace with an arbitrarily long or fast gesture without ever needing to know its total distance
    // up front (the browser clamps scrollLeft to the edge regardless of how far past it the gesture
    // tried to go, so a single relocation is always enough per genuine event -- no loop needed here
    // the way makeReachable needs one for an arbitrarily-distant button target). Runs unconditionally
    // (not gated to only-while-dragging) so it also covers touch-scroll, which never sets the native
    // `dragging` attribute makeReachable's callers could otherwise key off of.
    scroller.addEventListener('scroll', function () {
      if (pendingSelfScrolls > 0) {
        pendingSelfScrolls--;
        return;
      }
      extendIfAtEdge();
    });

    // Real bug fixed 2026-08-07 (found testing the fix above): the scroll-reactive extension only
    // ever sees the scroller AT rest exactly on an edge (0 or scrollWidth-clientWidth) -- that's the
    // carousel's only resting state on a 1-slide-of-headroom carousel like Care's citrus one, since
    // every relocation lands back on an edge by construction. Dragging further in the SAME direction
    // the carousel is already pinned against asks the browser to scroll past that edge, which it
    // clamps to a no-op -- scrollLeft never actually changes, so no 'scroll' event fires at all, and
    // the reactive extension above never gets a chance to run. Observed directly: after one forward
    // drag (which relocated and landed back at the start edge), five separate follow-up drags in the
    // SAME direction produced zero movement.
    //
    // Can't fix this by extending pre-emptively on 'mousedown'/'touchstart' alone, before the
    // gesture's direction is even known: at rest the scroller can only ever be AT one edge (0 XOR
    // maxScroll, never both -- the real slides only ever add up to exactly maxScroll of headroom
    // total, no matter how they're rotated), so blindly extending "whichever edge we're currently
    // on" is only correct for a drag that continues that same direction -- for a drag about to go
    // the OTHER way, it actively relocates the wrong end and lands exactly on the edge the new drag
    // needs to move away from, recreating the same stuck-immediately bug for that direction instead.
    // Needs the gesture's real direction, which only pointermove/touchmove actually carry.
    //
    // Mirrors (doesn't replace) the pieces of the native gesture this needs to see: 'pointerdown' as
    // the start signal (fires for both mouse and touch, so one listener covers both, unlike native's
    // own mouse-only 'mousedown' entry point), then the first 'pointermove' whose position has
    // genuinely moved from the start point to read a direction -- small deliberate threshold (2px)
    // so an in-place mousedown+pointerup (a plain click on a card, not a drag at all) never triggers
    // a relocation it doesn't need. Reads directly off the event's own clientX, not any native
    // internal state, so this needs no access to the native class's private drag fields. Disarms on
    // 'pointerup'/'pointercancel' so a released gesture can't leave a stale direction armed for the
    // next unrelated interaction.
    var dragOriginX = null;
    function armDragOrigin(event) {
      dragOriginX = event.clientX;
    }
    function disarmDragOrigin() {
      dragOriginX = null;
    }
    function extendForGestureDirection(event) {
      if (dragOriginX === null) return;
      var delta = dragOriginX - event.clientX;
      if (Math.abs(delta) < 2) return;
      dragOriginX = null;
      var maxScroll = scroller.scrollWidth - scroller.clientWidth;
      if (maxScroll <= 1) return;
      if (delta > 0 && scroller.scrollLeft >= maxScroll - 1) {
        relocateOne(1);
      } else if (delta < 0 && scroller.scrollLeft <= 1) {
        relocateOne(-1);
      }
    }
    scroller.addEventListener('pointerdown', armDragOrigin);
    document.addEventListener('pointermove', extendForGestureDirection);
    document.addEventListener('pointerup', disarmDragOrigin);
    document.addEventListener('pointercancel', disarmDragOrigin);

    // Real bug fixed 2026-08-07 (found while verifying the fix above, on a 12-product carousel --
    // a 4-product one wasn't enough to expose it): native select() opens with
    // `if (currentSlide === requestedSlideElement) return;`, where currentSlide is looked up as
    // `this.slides[this.current]` -- a live re-read of the (possibly since-reordered) slide array
    // at THIS numeric position. `this.current` was last written by a previous select() call using
    // whatever DOM order the framework's ref cache held at THAT moment; the cache is refreshed
    // asynchronously (MutationObserver), so by the time a later call reads it, the same number can
    // resolve to a different slide than the one it meant when written. After enough reorders this
    // can coincide with the slide we're about to request, silently turning a real step into a no-op.
    // The gate only exists to skip a redundant re-selection of the already-active slide -- something
    // that can never legitimately apply here, since we only ever call select() with a genuinely
    // different target -- so resync `current` to the real DOM index of the slide our own pointer
    // still considers active (by ID, immune to reorder drift), instead of the -1 sentinel a prior
    // pass used here.
    //
    // Real bug fixed 2026-08-08 (found testing Florida Citrus Trees' new true-1-up mobile
    // breakpoint -- the previous -1 sentinel was never exercised against `visibleSlides.length===1`
    // before, since no carousel reliably hit that exact state until this width existed): -1 defeats
    // the stale-cache guard above, but `this.slides[-1]` being undefined ALSO corrupts two other
    // reads inside the SAME select() call: (a) `isAdjacentSlide = Math.abs(requestedIndex -
    // current) <= 1` -- with current=-1, even a genuinely-adjacent single step (0 -> 1) computes
    // Math.abs(1 - (-1)) = 2, which is never <=1, so isAdjacentSlide is always wrongly false; (b)
    // when `!isAdjacentSlide && visibleSlides.length === 1` is true, native enters its
    // reorder-placeholder branch, whose OWN guard `if (!targetSlide || !currentSlide) return`
    // immediately fires (currentSlide is that same `this.slides[-1]` === undefined) -- so on a true
    // 1-visible-slide carousel, EVERY click silently no-op'd before ever reaching the code that
    // scrolls or updates `current`. Multi-slide carousels never hit this: visibleSlides.length!==1
    // skips that branch entirely, falling through to the simple path, which is why this went
    // uncaught until a genuinely single-card breakpoint existed. Fixed by resolving `current` to a
    // REAL, valid index (the slide our own `pointer` had before this step) rather than an
    // out-of-range placeholder -- that still reliably differs from requestedSlideElement (fixing
    // the original stale-cache no-op) while never resolving to `undefined` for any guard that reads
    // it. Falls back to -1 only if the previous slide-id can't be resolved to a live element
    // (shouldn't happen in practice, but no worse than the prior unconditional behavior).
    function goToSlideId(id, direction, event, options, fromId) {
      var slide = slides.filter(function (s) {
        return s.getAttribute('slide-id') === id;
      })[0];
      if (!slide) return;
      makeReachable(slide, direction);
      var fromSlide = fromId
        ? slides.filter(function (s) {
            return s.getAttribute('slide-id') === fromId;
          })[0]
        : null;
      var freshSlides = slideshowEl.slides;
      var fromIndex = fromSlide && freshSlides ? freshSlides.indexOf(fromSlide) : -1;
      slideshowEl.current = fromIndex;
      slideshowEl.select({ id: id }, event, options);
    }

    function step(direction, event, options) {
      var fromId = slideIds[pointer];
      pointer = (pointer + direction + slideIds.length) % slideIds.length;
      goToSlideId(slideIds[pointer], direction, event, options, fromId);
    }

    slideshowEl.next = function (event, options) {
      step(1, event, options);
    };
    slideshowEl.previous = function (event, options) {
      step(-1, event, options);
    };

    var dots = document.createElement('div');
    dots.className = 'vc-carousel-dots';

    var buttons = [];
    slides.forEach(function (slide, index) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'vc-carousel-dots__dot';
      dot.setAttribute('aria-label', 'Go to slide ' + (index + 1));
      dot.setAttribute('aria-current', index === 0 ? 'true' : 'false');
      dot.addEventListener('click', function () {
        // Walk one product at a time via the shortest direction, reusing the same safe
        // single-step primitive as the arrows, rather than relocating straight to the target --
        // see makeReachable's comment above: jumping more than one slide in one go can require
        // scrolling past the 0/max edge mid-relocation, which the browser clamps and desyncs the
        // compensation math. Only the final hop animates, matching the arrows' one-card glide.
        var hopsForward = ((index - pointer) % slideIds.length + slideIds.length) % slideIds.length;
        var hopsBackward = slideIds.length - hopsForward;
        var direction = hopsForward <= hopsBackward ? 1 : -1;
        var count = Math.min(hopsForward, hopsBackward);
        for (var i = 1; i < count; i++) {
          step(direction, undefined, { animate: false });
        }
        if (count > 0) step(direction, undefined, { animate: true });
      });
      dots.appendChild(dot);
      buttons.push(dot);
    });

    // Real bug fixed 2026-07-30: SlideshowSelectEvent always bubbles (assets/events.js), and each
    // card renders its OWN nested slideshow-component for its image gallery (swaps to the second
    // image on hover). That inner component's select() fires the same 'slideshow:select' event,
    // which bubbles up to this listener -- so hovering any card (even without navigating the
    // carousel) made the dots jump to reflect that card's internal image index. Heritage's own
    // code never listens across instances like this; filtering to events whose target is THIS
    // carousel's own slideshow-component (not a descendant one) fixes it at the root cause.
    slideshowEl.addEventListener('slideshow:select', function (event) {
      if (event.target !== slideshowEl) return;
      var activeId = event.detail.id;
      // Native drag-release (trigger:'drag' in slideshow.js) navigates directly, bypassing our own
      // step()/goToSlideId() -- resync our pointer to whatever it actually landed on so the NEXT
      // arrow or dot click continues from there instead of the drag's real starting point.
      var activeIndex = slideIds.indexOf(activeId);
      if (activeIndex >= 0) pointer = activeIndex;
      buttons.forEach(function (dot, index) {
        dot.setAttribute('aria-current', slideIds[index] === activeId ? 'true' : 'false');
      });
    });

    // Appended INSIDE the carousel wrapper, not as a sibling after it -- appending after made dots
    // inherit the parent grid's 50px gap on top of their own margin-top, doubling the spacing.
    var wrapper = slideshowEl.closest('.force-full-width') || slideshowEl;
    wrapper.insertAdjacentElement('beforeend', dots);
  }

  function initAll() {
    document
      .querySelectorAll(
        '[id^="shopify-section-"][id$="__product_list_trees"], [id^="shopify-section-"][id$="__product_list_family"], [id^="shopify-section-"][id$="__product_list_citrus"]'
      )
      .forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
